import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import './sub-nav.scss';

const subNavData = [
  { url: '/app/account', name: 'Overview' },
  { url: '/app/account/orderhistory', name: 'Orders' },
  { url: '/app/subs', name: 'Autoship' },
  { url: '/pets', name: 'My Pets' },
  { url: '/app/account/favorites', name: 'Favorites' },
  { url: '/app/account/reorder', name: 'Buy Again' },
  { url: '/app/account/giftcard', name: 'Gift Cards' },
  { url: '/pethealth/my-prescriptions', name: 'Prescriptions' },
  { url: '/pethealth', name: 'My Pet Health' },
  { url: '/app/account/clinics', name: 'My Vet Clinics' },
  { url: '/g/my-rescues', name: 'My Rescues' },
];

const SubNav = () => {
  const location = useLocation();
  return (
    <nav className="sub-nav" id="account-subnav">
      <ul className="sub-nav__container">
        {subNavData.map(({ url, name }, index) => (
          <li key={index} className={matchPath(location.pathname, url) ? 'sub-nav--selected' : ''}>
            <a href={url}>{name}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SubNav;
